export { default } from './Feed';
export { default as NewsSingle } from './Single';



// WEBPACK FOOTER //
// ./src/news/index.js